import { get, post, remove } from './api';
import routes from './end-points';

export const notificationsApi = {
  init: () => get(routes.notifications.init),
  detail: (id) => get(routes.notifications.detail(id)),
  unreads: () => get(routes.notifications.unreads),
  markAsRead: (id) => get(routes.notifications.markAsRead(id)),
};
